import _ from "lodash";

export const IMAGE_CDN = 'https://img.sumitas.jp/ph2';
export const MANAGE_DOMAIN = process.env.NODE_ENV === 'master'
  ? 'https://manage.sumitas-web.com'
  : 'https://stg.manage.sumitas-web.com';

/**
 * Get image URI from property saved images
 * @param propertySavedImages
 * @returns {string|undefined}
 */
export function getImageURI(propertySavedImages) {
  const propertySavedImageInOrder = _.minBy(propertySavedImages, (img) => img.propertyImages[0]?.image_ordering);
  return propertySavedImageInOrder?.uri;
}

/**
 * Load image asynchronously to check if it exists
 * @param src
 * @returns {Promise<boolean>}
 */
function loadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    const timeout = setTimeout(() => { img.src = ''; resolve(false); }, 3000);
    img.onload = () => { clearTimeout(timeout); resolve(true); };
    img.onerror = () => { clearTimeout(timeout); resolve(false); };
    img.src = src;
  });
}

/**
 * Get property image <img> tag with fallback
 * @param property
 * @param defaultImage
 * @param height
 * @param width
 * @returns {Promise<string>}
 */
export async function getPropertyImageTag(property, defaultImage, height = '150px', width = '150px') {
  if (!property.propertySavedImages?.length) {
    return `<img src="${defaultImage}" alt="" height="${height}" width="${width}">`;
  }

  const propertySavedImages = [];
  const division4Images = [];

  for (const savedImage of property.propertySavedImages) {
    const propertyImage = savedImage.propertyImages[0];
    const division = propertyImage?.division;
    // Only include images that are displayed with divisions other than 10 and 11.
    if (propertyImage?.image_ordering !== 0 && propertyImage?.non_display !== 1 && division !== '10' && division !== '11') {
      propertySavedImages.push(savedImage);
      if (division === '4') division4Images.push(savedImage);
    }
  }

  const images = division4Images.length ? division4Images : propertySavedImages;
  const imageURI = getImageURI(images);

  if (!imageURI) {
    return `<img src="${defaultImage}" alt="" height="${height}" width="${width}">`;
  }

  const path = imageURI.startsWith('/') ? imageURI : `/${imageURI}`;
  const cdnUrl = `${IMAGE_CDN}${path}`;
  const fallbackUrl = `${MANAGE_DOMAIN}${path}`;
  const isLoadCdnUrl = await loadImage(cdnUrl);
  const src = isLoadCdnUrl ? cdnUrl : fallbackUrl;
  return `<img src="${src}" alt="" height="${height}" width="${width}">`;
}
